import FlightListApp from "flights/list/app";
import FlightDetailPage from "flights/new/flightdetailpage/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const flightRoute: RouteObject = {
  path: "flight",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: FlightListApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: FlightDetailPage,
  }]
};